import React from 'react';
import './nav-line.scss';
import { Link, NavLink } from "react-router-dom";
import { routes } from './Nav';
import { MediaQueryContext } from '../MediaQueryContext';


class NavLine extends React.Component {
  static contextType = MediaQueryContext;
  constructor() {
    super();
    this.state = { scrollPosition: window.scrollY }
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
    
  }

  onScroll() {
    this.setState({ scrollPosition: window.scrollY });
  }
 

  render() {

    let style = {left: this.context.isMobile ? `calc(1em - ${this.state.scrollPosition}%)` : null};
    return (
      <div className="nav-line" style={style}>
        {routes.map((route, index) => <NavLink key={"nav-link-" + index} className="dot nav-dot" exact={true} activeclass="active" to={route.path}><span>{index}</span></NavLink>)}
      </div>
    );
  }
}

export default NavLine;
